import { render, staticRenderFns } from "./ReCaptchaPolicy.vue?vue&type=template&id=747e7605"
import script from "./ReCaptchaPolicy.vue?vue&type=script&lang=js"
export * from "./ReCaptchaPolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports